import React from 'react';

import { ReactComponent as CrossIconSvg } from '../../assets/icons/cross.svg';

const CrossIcon = ({ width = '20px', height = '20px' }: { width?: string; height?: string }) => {
  return (
    <div>
      <CrossIconSvg />
    </div>
  );
};

export default CrossIcon;
